import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import SmoothCollapse from 'react-smooth-collapse'
import Checkbox from 'components/input/checkbox'
import { Link } from 'react-router-dom'

import { 
	doClickEventListeners,
	parseFileArray
} from 'utils'

class Button extends Component {
	debounced = true
	buttonRef = null

	state = {
		imageFile: '',
		imagePreviewUrl: '',
		showDropdown: false,
		searchTerm: ''
	}

	handleClick = e => {
		if (this.props.dropDown) {
			this.setState({
				showDropdown: !this.state.showDropdown
			})
		} else {
			if (this.debounced) {
				this.debounced = false;
				if (!this.props.hasFile) {
					if (this.props.callback) {
						this.props.callback(e)
					}
				} else {
					this.inputRef.click()
				}

				setTimeout(_ => {
					this.debounced = true
				}, 10)
			}
		}
	}

	handleFileChange = e => {
		const allFiles = [...e.target.files]

		parseFileArray(allFiles, this.props.callback)

		e.target.value = null
	}

	handleChangeSearchTerm = value => {
		this.setState({
			searchTerm: value
		})
	}

	UNSAFE_componentWillMount() {
		doClickEventListeners(this.forceCloseMenu)
	}

	componentWillUnmount() {
		doClickEventListeners(this.forceCloseMenu, true)
	}

	componentDidUpdate = (prevProps, prevState) => {
		if (!prevState.showDropdown && this.state.showDropdown && this.searchRef) {
			this.searchRef.focus()
		}
	}

	forceCloseMenu = e => {
		if (this.buttonRef && !this.buttonRef.contains(e.target) && this.state.showDropdown) {
			this.setState({
				showDropdown: false
			})
		}
	}

	render() {
		const {
			disabled,
			dropDown,
			hasFile,
			size,
			level,
			icon,
			imgIcon,
			svgIcon,
			label,
			isLoading,
			noHover,
			hasCheckbox,
			isChecked,
			disableMultiple,
			className,
			link,
			forcePressed
		} = this.props

		const {
			showDropdown,
			searchTerm
		} = this.state

		let buttonClassName = 'button ' + size + ' ' + level
		
		if(className){
			buttonClassName += ' '+className
		}

		if (disabled) {
			buttonClassName += ' disabled'
		}

		if (dropDown) {
			buttonClassName += ` has-dropdown ${ dropDown.positionRight ? 'right' : ''}`
		}

		if (showDropdown) {
			buttonClassName += ' open'
		}

		if(noHover){
			buttonClassName += ' no-hover'
		}

		if(forcePressed){
			buttonClassName += ' force-pressed'
		}


		if(link){
			return (
				<a href={link}
					className={buttonClassName}
					target="_blank"
				>
					{ icon ?
						<Icon name={icon} />
					: null }
					{ label }
				</a>
			)
		}else if (hasFile) {
			return (
				<div 
					className={buttonClassName + ' file needsclick'} 
					onClick={_ => { this.handleClick() }}
				>
					{ !disabled &&
					<input 
						ref={input => this.inputRef = input} 
						onClick={e => { if (this.debounced) { e.preventDefault() } }} 
						type="file" 
						onChange={e => { this.handleFileChange(e) }} 
						multiple={!disableMultiple} 
					/>
					}
					{icon && <Icon name={icon} />}
					{ label }
				</div>
			);
		} else if (dropDown) {
			return (
				<div 
					className={buttonClassName} 
					onClick={e => { if (!disabled) { this.handleClick(e) } }} 
					ref={ref => this.buttonRef = ref}
				>
					{icon && <Icon name={icon} />}
					{ label }
					{
						dropDown ?
							<Icon name="angle-down" />
							: null
					}
					{dropDown ?
						<div className={this.state.showDropdown ? "button-dropdown open" : 'button-dropdown'}>
							<SmoothCollapse expanded={this.state.showDropdown}>
								{ dropDown.type == 'user' &&
									<div className="task-menu-search" onClick={e => e.stopPropagation()}>
										<input ref={ref => this.searchRef = ref} type="text" value={searchTerm} onChange={e => this.handleChangeSearchTerm(e.target.value)} />
									</div>
								}
								<ul className="button-dropdown-list">
									{
										dropDown.items.map((item, index) => {
											let itemLabel = null

											if(!item){
												return null
											}

											if(dropDown.type == 'sorting'){
												itemLabel = item.label
											}else{
												if(item.name){
													itemLabel = item.name
												}else{
													itemLabel = item.first_name + ' ' + item.last_name
												}

												if (!itemLabel.toLowerCase().includes(searchTerm.toLowerCase())) {
													return null
												}
											}

											return (
												<li key={item.id ? item.id : index} className={dropDown.selectedCheck(item) ? 'selected' : null}>
													<label>
														<Checkbox isChecked={dropDown.selectedCheck(item)} onChange={_ => { dropDown.selectCallback(item) }} />
														{itemLabel}
													</label>
												</li>
											)
										})
									}
								</ul>
							</SmoothCollapse>
						</div>
						: null
					}
				</div>
			);
		} else {
			let tempIcon = icon

			if(isLoading){
				if(icon){
					tempIcon = 'circle-o-notch fa-spin'
				}

				buttonClassName += ' disabled'
			}

			let iconMarkup = null

			if(hasCheckbox){
				iconMarkup = (
					<Checkbox
						isChecked={isChecked} 
						onChange={this.handleClick}
					/>
				)

				if(isChecked){
					buttonClassName += ' is-checked'
				}
			}else if(tempIcon){
				iconMarkup = (
					<Icon name={tempIcon} />
				)
			}else if(imgIcon){
				iconMarkup = (
					<img className="icon" src={document.base+'/images/icons/'+imgIcon+'.png'} />
				)
			}else if(svgIcon){
				iconMarkup = (
					svgIcon
				)
			}

			return (
				<button 
					className={buttonClassName} 
					onClick={e => { if (!disabled && !isLoading) { this.handleClick(e) } }} 
					ref={ref => this.buttonRef = ref}
				>
					{ iconMarkup }
					{
						isLoading ? 
						'One sec...' :
						label
					}
					{
						dropDown ?
							<Icon name="angle-down" />
							: null
					}
					{dropDown ?
						<div className={showDropdown ? "button-dropdown open" : 'button-dropdown'}>
							<SmoothCollapse expanded={showDropdown}>
								<div className="task-menu-search" onClick={e => e.stopPropagation()}>
									<input 
										ref={ref => this.searchRef = ref} 
										type="text" 
										value={searchTerm} 
										onChange={e => this.handleChangeSearchTerm(e.target.value)} 
									/>
								</div>
								<ul className="button-dropdown-list">
									{
										dropDown.items.map(item => {
											const nameString = item.first_name + ' ' + item.last_name

											if (!nameString.toLowerCase().includes(this.state.searchTerm.toLowerCase())) {
												return null;
											}

											return (
												<li 
													key={item.id} 
													className={dropDown.selectedCheck(item) ? 'selected' : null}
												>
													<label>
														<Checkbox 
															isChecked={dropDown.selectedCheck(item)} 
															onChange={_ => { dropDown.selectCallback(item) }} 
														/>
														{nameString}
													</label>
												</li>
											)
										})
									}
								</ul>
							</SmoothCollapse>
						</div>
						: null
					}
				</button>
			);

		}
	}
}

export default Button;
